import React, { Fragment, useContext, useEffect } from "react";
import {
  Form,
  Button,
  Loader,
  Card,
  Row,
  AccountNav,
  ViewContext,
  useAPI,
  Grid,
} from "components/lib";
import { contextType } from "react-quill";
const Axios = require("axios");

export function SanctionsView(props) {
  const context = useContext(ViewContext);
  const accountInfo = useAPI("/api/account");
  const [sanctionsEnabled, setSanctionsEnabled] = React.useState(
    accountInfo?.data?.sanctions_enabled
  );

  useEffect(() => {
    console.log("Sanctions enabled: ", accountInfo?.data?.sanctions_enabled);
    if (accountInfo?.data?.sanctions_enabled) {
      setSanctionsEnabled(true);
    } else {
      setSanctionsEnabled(false);
    }
  }
  , [accountInfo?.data?.sanctions_enabled]);

  const formData = {
    header: {
      title: "PEP/Sanctions Settings",
      type: "header",
    },
    sanctionsSources: {
      label: "PEP/Sanctions Sources",
      type: "radio",
      required: true,
      options: ["OFAC only", "All"],
      default: accountInfo?.data?.sanctions_settings?.sanctionsSources,
    },
    monitoring: {
      label: "Monitoring (check for PEP/Sanctions on all every 30 days). Additional charges may apply.",
      type: "switch",
      default: accountInfo?.data?.sanctions_settings?.monitoring,
    },
  };
  const toggleSanctions = async () => {
    const response = await Axios.post("/api/account/sanctions", {
      sanctions_enabled: !sanctionsEnabled,
    });
    setSanctionsEnabled(!sanctionsEnabled);
    context.notification.show(
      `PEP/Sanctions ${!sanctionsEnabled ? "enabled" : "disabled"}`,
      "success",
      true,
      "toast",
      `${!sanctionsEnabled ? "check" : "x"}`
    );
  };

  if (!accountInfo.data) {
    return <Loader />;
  }

  return (
    <Fragment>
      <AccountNav />
      <Grid>
        <Row>
          <h1>Toggle PEP/Sanctions</h1>
          <p className="text-xs leading-6">
            Current Status:{" "}
            {sanctionsEnabled ? "Enabled" : "Disabled"}
            <Button text="Toggle" small action={toggleSanctions}></Button>
            <p className="text-xs leading-6">
              Please refer to the <a href="https://identity.stackgo.io/account/billing">billing</a> page for more details on Adverse Media costs.
            </p>
          </p>
        </Row>
        <Row>
          <Card restrictWidth>
            <Form
              data={formData}
              url="/api/account/sanctions/select"
              method="post"
              buttonText="Save"
            />
          </Card>
        </Row>
      </Grid>
    </Fragment>
  );
}

// To Dos
// Enable Sanctions
// Y/N
// Save to account
// toggle state to active
// Select sources
// Render a form
// single ofac checkbox
// Fix backend
// update backend to use the data in accout info on checks
